// extracted by mini-css-extract-plugin
export default {"stat":"FirstAndLast_stat__QdtFd","cover":"FirstAndLast_cover__Fxi9u","item":"FirstAndLast_item__ZT5Qx"};